import { Box, Card, CardContent, CardHeader, styled } from '@mui/material';
import CreditsAmountSlider from '../CreditsAmountSlider';

export const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  borderRadius: theme.spacing(1),
}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  padding: 0,
  '.MuiCardHeader-content': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  '.MuiCardHeader-title': {
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
  },
  '.MuiCardHeader-subheader': {
    color: '#4b5563',
  },
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: 0,
}));
export const StyledSliderWrapper = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  borderRadius: theme.spacing(1),
  backgroundColor: '#f9fafb',
}));

export const StyledSlider = styled(CreditsAmountSlider)(() => ({}));
